module.exports = __webpack_public_path__ + "img/kr.af5e3a8c.png";